import React, { useState } from 'react';
import { Table } from '@fikasio/react-ui-components';
import { useTranslation } from 'react-i18next';
import useTimeout from 'use-timeout';
import EmptyTableRow from 'components/UI/EmptyTableRow';
import { Template } from 'services/templates/types';
import TemplateRow from './TemplateRow';

const TemplatesList = ({
  templates,
}) => {
  const [delay, setDelay] = useState(null);
  const [newTemplate, setNewTemplate] = useState<Template | null>(null);
  const { t } = useTranslation();

  useTimeout(() => {
    if (newTemplate) {
      document.getElementById(newTemplate.id)?.focus();
      setDelay(null);
      setNewTemplate(null);
    }
  }, delay);

  return templates && (
    <Table
      bordered
      hover
      responsive
    >
      <thead>
        <tr>
          <th>{t('comment')}</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {
          (!templates || !templates.length) && (
            <EmptyTableRow
              colSpan={2}
              message={t('noTemplatesToDisplay')}
            />
          )
        }
        {
          [...(templates || [])]
            .sort((t1, t2) => (t1.startTime < t2.startTime ? -1 : 1))
            .map(template => (
              <TemplateRow
                key={template.id}
                template={template}
              />
            ))
        }
      </tbody>
    </Table>
  );
}

export default TemplatesList;
